import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import useConfig from 'app/hooks/useConfig';
import { Container } from 'app/components';
import Wizard from './Wizard';
import { BookingSuccess, ReservationSuccess, BookingFailure } from './Order';
import { SectionPurchase } from './styles';

const propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

const Purchase = ({ match: { url } }) => {
  const { routes } = useConfig();

  return (
    <SectionPurchase>
      <Container>
        <Switch>
          <Route path={routes.wizard.pattern} component={Wizard} />
          <Route path={routes.paymentSuccess.pattern} component={BookingSuccess} />
          <Route path={routes.paymentFailure.pattern} component={BookingFailure} />
          <Route path={routes.reservationSuccess.pattern} component={ReservationSuccess} />

          <Redirect from={url} to={routes.wizard.pattern} />
        </Switch>
      </Container>
    </SectionPurchase>
  );
};

Purchase.propTypes = propTypes;
export default Purchase;
